"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("@chakra-ui/react");

var _react2 = _interopRequireWildcard(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var FileInfoBox = function FileInfoBox(props) {
  var _useState = (0, _react2.useState)(props.details),
      _useState2 = _slicedToArray(_useState, 2),
      details = _useState2[0],
      setDetails = _useState2[1];

  (0, _react2.useEffect)(function () {
    setDetails(props.details);
  }, [props.details]);

  var updateDetails = function updateDetails(key, value) {
    var updatedDetails = _objectSpread(_objectSpread({}, details), {}, _defineProperty({}, key, value));

    setDetails(updatedDetails);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Box, {
    borderWidth: "1px",
    w: 'xs',
    h: "100%",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
      m: 2,
      borderWidth: "1px",
      borderRadius: "lg",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Center, {
        h: "200",
        children: [props.previewImageSrc && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Image, {
          src: props.previewImageSrc,
          objectFit: "contain",
          alt: "",
          h: "100%"
        }), props.previewElement]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Stack, {
      direction: "row",
      p: 2,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, {
        orientation: "vertical"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Table, {
        size: "sm",
        variant: "unstyled",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tbody, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "Name"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Editable, {
                placeholder: "Enter a name",
                onChange: function onChange(nextValue) {
                  return updateDetails('fileName', nextValue);
                },
                onSubmit: function onSubmit() {
                  return props.onUpdate(details);
                },
                value: details.fileName,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.EditableInput, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.EditablePreview, {})]
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "File type"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Tag, {
                children: details.fileType
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "File size"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: details.fileSize || '-'
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "Created at"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: details.createdAt
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Tr, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Th, {
              children: "Modified at"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, {
              children: details.modifiedAt
            })]
          })]
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Stack, {
      direction: "row",
      p: 2,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Textarea, {
        onChange: function onChange(e) {
          return updateDetails('description', e.target.value);
        },
        onBlur: function onBlur() {
          return props.onUpdate(details);
        },
        value: details.description ? details.description : 'Add a description'
      })
    })]
  });
};

var _default = FileInfoBox;
exports["default"] = _default;